<template>
    <div class="tooltip-wrapper">
        <slot></slot>
    </div>
</template>

<script>
    import { bus } from '../app';
    export default {
        name: "Tooltip",

        data() {
            return {
                open: false
            }
        },
        props: {
            tooltipId: null
        },
        watch: {
            open: function (newOpen, oldOpen) {
                this.checkState();
            }
        },

        mounted() {
            let component = this;

            $(this.$el).find('a.tooltip-trigger').on('click', function (event) {
                event.preventDefault();
                component.toggle();
                //emit id of current tooltip to close other tooltips
                if(component.tooltipId) {
                    bus.$emit('closeTooltips', component.tooltipId)
                }
            })

            document.addEventListener('click', function(e){
                if(e.target.matches('.tooltip-trigger') || e.target.matches('.trigger-icon')) {
                    return;
                }
                if(component.open){
                    component.open = false;
                }
            })
        },

        methods: {
            toggle: function() {
                this.open = !this.open;
            },

            checkState: function () {
                if (this.open && !this.isOpen) {
                    this.openTip();
                } else if (!this.open && this.isOpen) {
                    this.closeTip();
                }
            },

            openTip: function() {
                this.$el.setAttribute('state-active', 'true');
                this.isOpen = true;
            },

            closeTip: function() {
                this.$el.setAttribute('state-active', 'false');
                this.isOpen = false;
            },
        },
        created() {
            bus.$on('closeTooltips', (id) => {
                if(id !== this.tooltipId) {
                    this.open = false;
                }
            })
        }
    }
</script>

<style scoped>

</style>
